module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('app-header', {
    attrs: {
      "icon": "factory"
    }
  }, [_vm._v("\n        Détenteurs\n    ")]), _vm._v(" "), _c('action-bar', {
    attrs: {
      "back": {
        name: 'home'
      }
    }
  }, [_c('router-link', {
    staticClass: "btn add btn-full",
    attrs: {
      "id": "main-action",
      "event": "",
      "to": "new-detenteur"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.checkCanEdit('new-detenteur')
      }
    }
  }, [_c('i', {
    staticClass: "icon-add"
  }), _vm._v(" "), _c('strong', [_vm._v("Ajouter")]), _vm._v(" un détenteur\n        ")])], 1), _vm._v(" "), _c('filter-bar', {
    attrs: {
      "placeholderFilter": "Recherche par Nom, Code client, Adresse...",
      "type-history": "detenteur"
    },
    on: {
      "searchBarChanged": _vm.updateSearch
    }
  }), _vm._v(" "), (_vm.asyncDetenteurs === true) ? _c('div', {
    staticClass: "infoAsync"
  }, [_c('p', [_c('img', {
    staticClass: "spinner-load",
    attrs: {
      "src": require("../../img/spinner-load.gif")
    }
  }), _vm._v(" Synchronisation en cours en arrière plan")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list",
    attrs: {
      "id": "detenteurs-items"
    }
  }, _vm._l((_vm.paginatedList), function(detenteur) {
    return _c('detenteur-item', {
      key: detenteur.id,
      attrs: {
        "detenteur": detenteur,
        "typeuser": _vm.typeUser
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-buttons"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginator.showPreviousButton && !_vm.strSearch),
      expression: "paginator.showPreviousButton && !strSearch"
    }],
    on: {
      "click": _vm.previousPage
    }
  }, [_vm._v("Page précédente")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginator.showNextButton && !_vm.strSearch),
      expression: "paginator.showNextButton && !strSearch"
    }],
    on: {
      "click": _vm.nextPage
    }
  }, [_vm._v("Page suivante")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fb89a88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/detenteur/ListeDetenteurs.vue
// module id = 745
// module chunks = 0